export default (
  state = {
    selected: 'sizeguide',
    inputContent: '',
  },
  action
) => {
  switch (action.type) {
    case 'SELECTED_SIZE_TAB':
      return {
        ...state,
        selected: action.payload,
      };
    default:
      return state;
  }
};
